import { render } from "./devicestatus.vue?vue&type=template&id=3e89b06c&scoped=true"
import script from "./devicestatus.vue?vue&type=script&lang=js"
export * from "./devicestatus.vue?vue&type=script&lang=js"

import "./devicestatus.vue?vue&type=style&index=0&id=3e89b06c&scoped=scoped&lang=css"
script.render = render
script.__scopeId = "data-v-3e89b06c"

export default script